import { Box, useClassNames } from '@factorialco/deprecated-design-system'

import {
  HeaderCellsHoverContent,
  HeaderCellsHoverFooter,
  HeaderCellsHoverHeader,
} from 'modules/project_management/components/Schedule/Body/ScheduleItem/HeaderRow/HeaderCellsHover'
import 'modules/project_management/components/Schedule/Body/ScheduleItem/index.styles.css'
import { stylesRefs } from 'modules/project_management/components/Schedule/Body/ScheduleItem/stylesRefs'
import { HeaderCellType } from 'modules/project_management/components/Schedule/Body/ScheduleItem/types'
import { gridArea } from 'modules/project_management/components/Schedule/Body/ScheduleItem/utils'
import HoverScheduleCard from 'modules/project_management/components/Schedule/HoverScheduleCard'
import ScheduleCellText from 'modules/project_management/components/Schedule/ScheduleCellText'

interface IHeaderOffDaysCellProps {
  data: HeaderCellType
}

const HeaderOffDaysCell = ({ data }: IHeaderOffDaysCellProps) => {
  const cx = useClassNames(stylesRefs)

  return (
    <Box
      className={cx('scheduleItemHeaderCell')}
      style={{
        ...gridArea(data.rowStart, data.columnStart, data.rowSpan, data.columnSpan),
      }}
    >
      <HoverScheduleCard
        content={<HeaderCellsHoverContent data={data} />}
        footer={<HeaderCellsHoverFooter data={data} />}
        header={<HeaderCellsHoverHeader data={data} />}
      >
        <Box
          className={cx('mergedCellContent')}
          flexDirection="column"
          flexNoShrink
          background="champagne400"
        >
          <Box flexDirection="row" alignItems="center">
            <ScheduleCellText minutes={data.minutesOff} short={data.columnSpan === 1} />
          </Box>
        </Box>
      </HoverScheduleCard>
    </Box>
  )
}

export default HeaderOffDaysCell
